export const getTenantContext = () => {
  const el = document.getElementById("__TENANT_CONTEXT__");
  if (!el) {
    return {
      tenantId: undefined,
      tenantDomain: undefined,
    };
  }

  try {
    const tenantContext = JSON.parse(el.textContent ?? "");
    return {
      tenantId: tenantContext?.tenantId,
      tenantDomain: tenantContext?.tenantDomain || tenantContext?.domain,
    };
  } catch (err) {
    console.error("Invalid tenant context JSON", err);
    return {
      tenantId: undefined,
      tenantDomain: undefined,
    };
  }
};
